exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-select .vs__dropdown-menu {\n  height: 150px !important;\n}\r\n", ""]);

// exports
